// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_tax_mode.ml",
      88,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "TaxMode"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    });

const Common = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_tax_mode.ml",
      147,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "TaxMode"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_tax_mode.ml",
      204,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "TaxMode"
        ]]
    });

const TaxMode = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_tax_mode.ml",
      259,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.common.v1.TaxMode";
}

function to_int(param) {
  switch (param) {
    case /* TAX_MODE_UNSPECIFIED */0 :
        return 0;
    case /* TAX_MODE_STANDARD */1 :
        return 100;
    case /* TAX_MODE_KAZ_SNR_PATENT */2 :
        return 200;
    case /* TAX_MODE_KAZ_SNR_FIXED */3 :
        return 240;
    case /* TAX_MODE_KAZ_SNR_USN */4 :
        return 300;
    case /* TAX_MODE_KAZ_SNR_FARMING_LAND */5 :
        return 400;
    case /* TAX_MODE_KAZ_SNR_FARMING_PRODUCE */6 :
        return 440;
    case /* TAX_MODE_KAZ_SNR_RETAIL */7 :
        return 500;
    case /* TAX_MODE_KAZ_SNR_MOBILE */8 :
        return 600;
    
  }
}

function from_int_exn(n) {
  if (n >= 300) {
    if (n < 441) {
      if (n > 439 || n < 301) {
        if (n >= 440) {
          return /* TAX_MODE_KAZ_SNR_FARMING_PRODUCE */6;
        } else {
          return /* TAX_MODE_KAZ_SNR_USN */4;
        }
      } else if (n !== 400) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* TAX_MODE_KAZ_SNR_FARMING_LAND */5;
      }
    } else if (n !== 500) {
      if (n !== 600) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* TAX_MODE_KAZ_SNR_MOBILE */8;
      }
    } else {
      return /* TAX_MODE_KAZ_SNR_RETAIL */7;
    }
  } else if (n >= 101) {
    if (n !== 200) {
      if (n !== 240) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* TAX_MODE_KAZ_SNR_FIXED */3;
      }
    } else {
      return /* TAX_MODE_KAZ_SNR_PATENT */2;
    }
  } else if (n !== 0) {
    if (n >= 100) {
      return /* TAX_MODE_STANDARD */1;
    } else {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
  } else {
    return /* TAX_MODE_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* TAX_MODE_UNSPECIFIED */0 :
        return "TAX_MODE_UNSPECIFIED";
    case /* TAX_MODE_STANDARD */1 :
        return "TAX_MODE_STANDARD";
    case /* TAX_MODE_KAZ_SNR_PATENT */2 :
        return "TAX_MODE_KAZ_SNR_PATENT";
    case /* TAX_MODE_KAZ_SNR_FIXED */3 :
        return "TAX_MODE_KAZ_SNR_FIXED";
    case /* TAX_MODE_KAZ_SNR_USN */4 :
        return "TAX_MODE_KAZ_SNR_USN";
    case /* TAX_MODE_KAZ_SNR_FARMING_LAND */5 :
        return "TAX_MODE_KAZ_SNR_FARMING_LAND";
    case /* TAX_MODE_KAZ_SNR_FARMING_PRODUCE */6 :
        return "TAX_MODE_KAZ_SNR_FARMING_PRODUCE";
    case /* TAX_MODE_KAZ_SNR_RETAIL */7 :
        return "TAX_MODE_KAZ_SNR_RETAIL";
    case /* TAX_MODE_KAZ_SNR_MOBILE */8 :
        return "TAX_MODE_KAZ_SNR_MOBILE";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "TAX_MODE_KAZ_SNR_FARMING_LAND" :
        return /* TAX_MODE_KAZ_SNR_FARMING_LAND */5;
    case "TAX_MODE_KAZ_SNR_FARMING_PRODUCE" :
        return /* TAX_MODE_KAZ_SNR_FARMING_PRODUCE */6;
    case "TAX_MODE_KAZ_SNR_FIXED" :
        return /* TAX_MODE_KAZ_SNR_FIXED */3;
    case "TAX_MODE_KAZ_SNR_MOBILE" :
        return /* TAX_MODE_KAZ_SNR_MOBILE */8;
    case "TAX_MODE_KAZ_SNR_PATENT" :
        return /* TAX_MODE_KAZ_SNR_PATENT */2;
    case "TAX_MODE_KAZ_SNR_RETAIL" :
        return /* TAX_MODE_KAZ_SNR_RETAIL */7;
    case "TAX_MODE_KAZ_SNR_USN" :
        return /* TAX_MODE_KAZ_SNR_USN */4;
    case "TAX_MODE_STANDARD" :
        return /* TAX_MODE_STANDARD */1;
    case "TAX_MODE_UNSPECIFIED" :
        return /* TAX_MODE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, TaxMode, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "TaxMode"
        ]]
    }, V1, {
      TaxMode: TaxMode
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "TaxMode"
              ]]
          },
          "V1"
        ]]
    }, Common, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "TaxMode"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    }, Buhta, {
      Common: Common
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
